import { useEffect, useState } from "react";
import { editBasket, sendOrder } from "../configs/ordersConfig";
import { Link } from "react-router-dom";
import { getDeliveriesWithWeight, slugifyText } from "../configs/productsConfig";
import { HomeDeliveryComponent, LockerDeliveryComponent } from "./DeliveryComponents";
import toast from "react-hot-toast";


export function BasketProducts({ productsInBasket, setProductsInBasket, productsVariables, selectedDelivery, setSelectedDelivery, setDeliveries, deliveries }) {

    const [sumPrice, setSumPrice] = useState({ products: 0, delivery: 0, productsWithDelivery: 0 });
    const [weight, setWeight] = useState(-1)

    useEffect(() => {
        if (productsInBasket.length > 0) {
            calculateSumPrice();
            calculateWeight(productsInBasket, productsVariables);
        }
    }, [productsInBasket, selectedDelivery, productsVariables]);

    useEffect(() => {
        setSelectedDelivery({
            deliveryId : null,
            deliveryCode: null
        })
    }, [deliveries]);

    const checkStock = (product) => {

        const stock = productsVariables.find(
            (variable) =>
                variable.productId == product.productId &&
                variable.productOptionId == product.productOptionId
        )?.stock;

        return stock === 0 ? false : stock;
    };

    const calculateWeight = async (updatedProductsInBasket, variablesData) => {

        let productsWeight = 0;
        updatedProductsInBasket.forEach((product) => {
            const weight = variablesData.find(
                (variable) =>
                    variable.productId == product.productId &&
                    variable.productOptionId == product.productOptionId
            )?.weight;
            productsWeight += parseInt(product.quantity) * parseFloat(weight);
        });
      if (!isNaN(productsWeight) && productsWeight != weight) {
            setWeight(productsWeight)
            const deliveryData = await getDeliveriesWithWeight(productsWeight);
            setDeliveries(deliveryData);
        };
    };

    const calculateSumPrice = () => {

        const deliveryPrice = deliveries.find(
            (variable) =>
                variable.id == selectedDelivery.deliveryId
        )?.price

        let productsPrice = 0;

        productsInBasket.forEach((product) => {
            const price = productsVariables.find(
                (variable) =>
                    variable.productId == product.productId &&
                    variable.productOptionId == product.productOptionId
            )?.price;
            productsPrice += parseInt(product.quantity) * parseFloat(price);
        });
        if (selectedDelivery.deliveryId != null) {
            setSumPrice({ products: productsPrice, productsWithDelivery: deliveryPrice + productsPrice, delivery: deliveryPrice });
        } else {
            setSumPrice({ products: productsPrice, productsWithDelivery: 0, delivery: 0 });
        }

    };

    const deleteProductFromBasket = (productOptionId) => {
        const updatedBasket = productsInBasket.filter(product => product.productOptionId !== productOptionId);
        editBasket(updatedBasket);
        setProductsInBasket(updatedBasket);
    };

    const handleOrderedPiece = (index, change) => {
        setProductsInBasket((prevData) => {
            const updatedData = [...prevData];

            const updatedPiece = Math.max(0, Math.min(checkStock(updatedData[index]), updatedData[index].quantity + change));

            if(updatedPiece == 0){
                updatedData.splice(index, 1);
            } else {
                updatedData[index] = {
                ...updatedData[index],
                quantity: updatedPiece,
                };
            };

            editBasket(updatedData);

            return updatedData;
        });
    };

    return (
        <div className="col-lg-9 col-11">
            <div className="table-responsive">
                <h5>Termékek:</h5>
                <table className="table table-striped">
                    <tbody>
                        {
                            productsInBasket.map((product, index) => {
                                const stock = checkStock(product);
                                return <tr key={index}>
                                    <td className={`align-middle p-1 ${stock ? 'd-none d-md-block' : 'd-block'}`}>
                                        <button className="btn" onClick={() => deleteProductFromBasket(product.productOptionId)}>X</button>
                                    </td>

                                    <td className="align-middle p-1">
                                        <Link className="text-dark text-decoration-none" to={`/products/${product.tableName}/${slugifyText(product.productName)}__${product.productId}`}>{product.productName}</Link>
                                    </td>

                                    <td className="align-middle p-1">
                                        {product.productOption == 1 ? "" : product.productOption}
                                    </td>

                                    <td className={`align-middle ${stock ? '' : 'd-none'}`}>
                                        <div className="d-flex">
                                            <button className={`btn bg-secondary-subtle rounded-0 rounded-start border`} onClick={() => handleOrderedPiece(index, -1)}>-</button>
                                            <span className="form-control px-1 w-25 rounded-0 border-start-0 border-end-0 text-center bg-light">{product.quantity}</span>
                                            <button className="btn bg-secondary-subtle rounded-0 rounded-end border" onClick={() => handleOrderedPiece(index, +1)}>+</button>
                                        </div>
                                    </td>

                                    <td className="align-middle p-1">
                                        {stock ? (() => {
                                            const variable = productsVariables.find(
                                                (v) =>
                                                    v.productId === product.productId &&
                                                    v.productOptionId == product.productOptionId
                                            );
                                            return variable
                                                ? `${variable.price} Ft/${variable.unitType === 'piece' ? 'Darab' : 'Csomag'}`
                                                : 'Nincs ár!';
                                        })() : 'Elfogyott!'}
                                    </td>
                                </tr>
                            })
                        }
                    </tbody>
                </table>
            </div>

            <div>
                <h5>Szállítási opciók: </h5>
                <div className="d-flex mx-auto align-items-center justify-content-around border-bottom">

                    {deliveries.map((delivery) => (
                        <div className="form-check p-0" key={delivery.id}>
                            <input
                                className="me-2"
                                type="radio"
                                id={delivery.id}
                                name="delivery"
                                checked={selectedDelivery.deliveryId === delivery.id}
                                onChange={() => setSelectedDelivery({deliveryId : delivery.id, deliveryCode : delivery.deliveryCode})}
                            />
                            <label className="form-check-label" htmlFor={delivery.id}>
                                <span className="fw-medium fs-7">{delivery.name}</span> {delivery.price} Ft
                            </label>
                        </div>
                    ))}
                </div>

            </div>

            <div className="d-flex justify-content-center mt-4">

                <div className="me-4">
                    <h5 className="mb-4">Rendelés összegzése</h5>
                    <div className="d-flex justify-content-between">
                        <h6>Összeg:</h6>
                        <h6 className="text-end px-2">{isNaN(sumPrice.products) ? '-' : sumPrice.products + 'Ft'}</h6>
                    </div>

                    <div className="d-flex justify-content-between mb-2">
                        <h6>Szállítási költség:</h6>
                        <h6 className="text-end px-2">{sumPrice.delivery != 0 && sumPrice.delivery != undefined ? sumPrice.delivery + 'Ft' : '-'}</h6>
                    </div>
                </div>

                <div className="ms-4">

                    <h5 className="mt-2">Végösszeg:</h5>
                    <h5>{isNaN(sumPrice.productsWithDelivery) || sumPrice.productsWithDelivery == 0 ?  '-' : sumPrice.productsWithDelivery + 'Ft'}</h5>

                </div>

            </div>

        </div>
    );
};



export function BasketDeliveryData({deliveryData, billingData, selectedDelivery, setDeliveryData, setBillingData, buyWithoutRegistration}) {

    const [isSame, setIsSame] = useState(false);

    useEffect(()=>{
        if(isSame){
            setBillingData(deliveryData);
        }
    },[isSame, deliveryData]);

    return (
        <div className="col-12 d-flex justify-content-center">
            <form className='d-flex flex-column col-12 col-md-8 px-3'>

                {
                    selectedDelivery.deliveryCode == 0 
                    ? <HomeDeliveryComponent setIsSame={setIsSame} isSame={isSame} deliveryData={deliveryData} setDeliveryData={setDeliveryData} buyWithoutRegistration={buyWithoutRegistration}/> 
                    : <LockerDeliveryComponent deliveryCode={selectedDelivery.deliveryCode} setDeliveryData={setDeliveryData}/>
                }
          
                <div className={`${isSame ? 'd-none' : ''}`}>
                    <h5 className="fs-5">Számlázási adatok</h5>
                    <div className="form-floating mb-3">

                        <input type="text" className={`form-control`} id="billingName" value={billingData.name} onChange={(e) => setBillingData({ ...billingData, name: e.target.value })} placeholder="" />

                        <label htmlFor="billingName">Név</label>

                    </div>

                    <div className={`form-floating mb-3 ${buyWithoutRegistration ? '' : 'd-none'}`} >
                        <input type="email" className={`form-control`} id="billingMail" value={billingData.email} onChange={(e) => setBillingData({ ...billingData, email: e.target.value })} placeholder="" />

                        <label htmlFor="billingMail">Email cím</label>
                    </div>

                     <div className="form-floating mb-3">
                        <input type="text" className={`form-control`} id="billingPhoneNumber" value={billingData.phoneNumber} onChange={(e) => setBillingData({ ...billingData, phoneNumber: e.target.value })} placeholder="" />

                        <label htmlFor="billingPhoneNumber">Telefonszám</label>
                    </div>

                    <div className="form-floating mb-3">

                        <input type="number" className={`form-control`} id="billingPostalcode" value={billingData.postalcode} onChange={(e) => setBillingData({ ...billingData, postalcode: e.target.value })} placeholder="8000" />

                        <label htmlFor="billingPostalcode">Irányítószám</label>

                    </div>

                    <div className="form-floating mb-3">

                        <input type="text" className={`form-control`} id="billingCity" value={billingData.city} onChange={(e) => setBillingData({ ...billingData, city: e.target.value })} placeholder="Székesfehérvár" />

                        <label htmlFor="billingCity">Város</label>

                    </div>

                    <div className="form-floating mb-3">

                        <input type="text" className={`form-control`} id="billingStreet" value={billingData.street} onChange={(e) => setBillingData({ ...billingData, street: e.target.value })} placeholder="Példa utca" />

                        <label htmlFor="billingStreet">Utca</label>

                    </div>

                    <div className="form-floating mb-3">

                        <input type="text" className={`form-control`} id="billingHouseNumber" value={billingData.houseNumber} onChange={(e) => setBillingData({ ...billingData, houseNumber: e.target.value })} placeholder="82/G" />

                        <label htmlFor="billingHouseNumber">Ház szám</label>

                    </div>


                    <div className="form-floating mb-3">

                        <input type="text" className={`form-control`} id="billingNote" value={billingData.note} onChange={(e) => setBillingData({ ...billingData, note: e.target.value })} placeholder="Emelet, ajtó" />

                        <label htmlFor="billingNote">Megjegyzés (Emelet, ajtó)</label>

                    </div>
                </div>

            </form>
        </div>
    );
};


export function BasketSummary({productsInBasket, productsVariables, deliveryData, billingData, deliveries, selectedDelivery, buyWithoutRegistration }) {
    
    const [ASZF, setASZF] = useState(false);

    const sendOrderSummary = async () => {
        if (!ASZF) {
            toast.error('A folytatáshoz el kell fogadnod a felhasználási feltételeket!');
            return;
        }
        const orderDetails = {
            ASZF: ASZF,
            products: productsInBasket,
            deliveryOptionId: selectedDelivery.deliveryId,
            deliveryData: deliveryData,
            billingData: billingData.name != '' ? billingData : null
        };
       
        const url = await sendOrder(orderDetails);

        if (url) {
            window.location.href = url;
        } else {
            console.error('URL is not provided by the backend');
        };
    };

    return (
        <div className="col-12 d-flex justify-content-center">
            <div className="col-12 d-flex flex-column col-md-9 px-3">
                <h5 className="mb-2 fs-5">Termékek:</h5>
                <table className="table table-striped mb-4">
                    <tbody>
                        {
                            productsInBasket.map((product, index) => (
                                <tr key={index}>

                                    <td className="align-middle">
                                        {product.productName}
                                    </td>

                                    <td className="align-middle">
                                        {product.productOption == 1 ? "" : product.productOption}
                                    </td>

                                    <td className="align-middle">{product.quantity} db</td>

                                    <td className="align-middle">{productsVariables.find(
                                        (variable) =>
                                            variable.productId == product.productId &&
                                            variable.productOptionId == product.productOptionId
                                    )?.price} Ft/db</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>

                 <div className="d-flex flex-row">
                    <h5 className="mb-2 fs-5">Szállítási opció:</h5>
                    {selectedDelivery.deliveryId !== null && (() => {
                        const selected = deliveries.find(delivery => delivery.id == selectedDelivery.deliveryId);
                        return selected ? (
                            <p className="ms-2 mb-0">{selected.name} {selected.price} Ft</p>
                        ) : null;
                    })()}
                </div>

                <div className="d-flex flex-row">
                    <h5 className="mb-3 fs-5">Összesen:</h5>
                    <p className="ms-2 mb-0">
                        {
                            (() => {
                                const totalProductsPrice = productsInBasket.reduce((sum, product) => {
                                    const variable = productsVariables.find(
                                        (variable) =>
                                            variable.productId == product.productId &&
                                            variable.productOptionId == product.productOptionId
                                    );
                                    const price = variable ? variable.price : 0;
                                    return sum + price * product.quantity;
                                }, 0);

                                const delivery = deliveries.find(
                                    (delivery) => delivery.id == selectedDelivery.deliveryId
                                );
                                const deliveryPrice = delivery ? delivery.price : 0;

                                const total = totalProductsPrice + deliveryPrice;

                                return total.toLocaleString('hu-HU'); 
                            })()
                        } Ft
                    </p>
                </div> 

                <h5 className="mb-2 fs-5">Szállítási adatok:</h5>
                <table className="table table-striped mb-4">
                    <tbody>
                        <tr>
                            <td>Név:</td>
                            <td>{deliveryData.name}</td>
                        </tr>

                        {deliveryData.phoneNumber.trim() !== '' && (
                            <tr>
                                <td>Telefonszám:</td>
                                <td>{deliveryData.phoneNumber}</td>
                            </tr>
                        )}

                        <tr>
                            <td>Cím:</td>
                            <td>
                                {deliveryData.postalcode}, {deliveryData.city} {deliveryData.street} {deliveryData.houseNumber}
                            </td>
                        </tr>

                        {deliveryData.note.trim() !== '' && (
                            <tr>
                                <td>Megjegyzés:</td>
                                <td>{deliveryData.note}</td>
                            </tr>
                        )}
                    </tbody>
                </table>


                <div className={`${billingData.name != '' ? '' : 'd-none'} col-12`}>
                    <h5 className="mb-2 fs-5">Számlázási adatok:</h5>
                    <table className="table table-striped mb-4">
                        <tbody>
                            <tr>
                                <td>Név:</td>
                                <td>{billingData.name}</td>
                            </tr>
                             <tr className={` ${buyWithoutRegistration ? '' : 'd-none'}`}>
                                <td>Email</td>
                                <td>{billingData.email}</td>
                            </tr>
                            <tr>
                                <td>Telefonszám</td>
                                <td>{billingData.phoneNumber}</td>
                            </tr>
                            <tr>
                                <td>Cím:</td>
                                <td>{billingData.postalcode}, {billingData.city} {billingData.street} {billingData.houseNumber}</td>
                            </tr>
                            <tr>
                                <td>Megjegyzés:</td>
                                <td>{billingData.note}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>               

                <div className="form-check mb-3">
                    <input className="form-check-input" type="checkbox" value={ASZF} onChange={() => setASZF(!ASZF)} id="ASZF" />
                    <label className="form-check-label" htmlFor="ASZF">
                        Az <a href="/Aszf.pdf" target="_blank" rel="noopener noreferrer">Általános Szerződési Feltételeket</a> elolvastam és elfogadom.
                    </label>
                </div>
                <button className="btn btn-home-primary mx-auto" onClick={() => sendOrderSummary()}>Megrendelés elküldése</button>
            </div>
        </div>
    )
};
